<template>
  <div class="container">
    <div class="handle-box">
      <el-form ref="queryCondition" label-width="120px" :model="queryCondition" class="searchForm">
        <el-row>
          <el-col :span="24">
            <el-row :gutter="20">
              <el-col :span="6">
                <el-form-item label="报价确认单据编号" prop="sourcingNo">
                  <el-input class="handle-input" v-model="queryCondition.sourcingNo" clearable placeholder="请输入报价确认单据编号" style="width:100%"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="产品报价申请单" prop="applyNo">
                  <el-input class="handle-input" v-model="queryCondition.applyNo" clearable placeholder="请输入产品报价申请单" style="width:100%"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="主题" prop="subject">
                  <el-input class="handle-input" v-model="queryCondition.subject" clearable placeholder="请输入主题" style="width:100%"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="供应商" prop="tmSupplierId">
                  <ic-select table="BASE" field="CARRIER" filterable clearable v-model="queryCondition.tmSupplierId" style="width:100%"></ic-select>
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
          <el-collapse-transition>
            <el-col :span="24" v-if="isShow">
              <el-row :gutter="20">
                <el-col :span="6">
                  <el-form-item label="创建日期(从)" prop="dateFrom">
                    <el-date-picker value-format="yyyy-MM-dd" v-model="queryCondition.dateFrom" type="date" :placeholder="$t('common.selDate')" style="width:100%"></el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="创建日期(至)" prop="dateTo">
                    <el-date-picker value-format="yyyy-MM-dd" v-model="queryCondition.dateTo" type="date" :placeholder="$t('common.selDate')" style="width:100%"></el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="审核日期(从)" prop="auditDateStart">
                    <el-date-picker value-format="yyyy-MM-dd" v-model="queryCondition.auditDateStart" type="date" :placeholder="$t('common.selDate')" style="width:100%"></el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="审核日期(至)" prop="auditDateEnd">
                    <el-date-picker value-format="yyyy-MM-dd" v-model="queryCondition.auditDateEnd" type="date" :placeholder="$t('common.selDate')" style="width:100%"></el-date-picker>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="6">
                  <el-form-item label="创建人" prop="creater">
                    <el-input class="handle-input" v-model="queryCondition.creater" clearable style="width:100%"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item :label="$t('quoteByLine.sourcing.auditor')" prop="auditor">
                    <el-input class="handle-input" v-model="queryCondition.auditor" clearable style="width:100%"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item :label="$t('common.status')" prop="status">
                    <ic-select clearable table="TT_SOURCING" class="handle-input" field="STATUS" v-model="queryCondition.status" style="width:100%"></ic-select>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="非标准线路运费" prop="isSpecialFreight">
                    <el-select class="handle-input" v-model="queryCondition.isSpecialFreight" clearable placeholder="非标准线路运费" style="width:100%">
                      <el-option :label="$t('common.all')" value=""></el-option>
                      <el-option :key="item.key" v-for="item in isSpecialFreightList" :label="item.label" :value="item.key"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="6">
                  <el-form-item label="8位码" prop="eightBitCodesStr">
                    <el-input v-model="queryCondition.eightBitCodesStr" type="textarea" :autosize="{ minRows: 2, maxRows: 4}" clearable class="handle-input" placeholder="请输入8位码" style="width:100%"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-col>
          </el-collapse-transition>
        </el-row>
        <el-row type="flex" justify="center" align="middle">
          <el-button size="mini" type="primary" @click="setTable(1)">查询</el-button>
          <el-button size="mini" type="primary" @click="restQueryForm('queryCondition')">重置</el-button>
          <span class="arrowDown" @click="isShow=!isShow">{{isShow?'收缩':'展开'}}<i :class="isShow?'el-icon-arrow-up iconBtn':'el-icon-arrow-down iconBtn'"></i></span>
        </el-row>
      </el-form>
    </div>
    <div class="action-btn-row">
      <el-button size="mini" class="btn" type="primary" v-acl="Sourcing-productSendSourcingMailt" @click="sendMail">发送中标通知</el-button>
    </div>
    <el-table :data="tableData" ref="dataTable" border max-height='480' highlight-current-row @selection-change="handleSelectionChange" row-key="ttSourcingProductId" class="table">
      <el-table-column type="selection" width="55" align="center" fixed :reserve-selection="true"></el-table-column>
      <el-table-column show-overflow-tooltip sortable prop="sourcingNo" label="报价确认单据编号" min-width="140px" fixed>
        <template slot-scope="scope">
          <div @click="showDetail(scope.row.sourcingNo)" class="a-link">{{scope.row.sourcingNo}}</div>
        </template>
      </el-table-column>
      <el-table-column show-overflow-tooltip sortable prop="applyNo" label="产品报价申请单" min-width="130px" fixed>
        <template slot-scope="scope">
          <div @click="openQuotationApplyDetail(scope.row)" class="a-link">{{scope.row.applyNo}}</div>
        </template>
      </el-table-column>
      <el-table-column show-overflow-tooltip sortable prop="subject" label="主题" min-width="120px"></el-table-column>
      <el-table-column show-overflow-tooltip sortable prop="eightBitCode" label="8位码" min-width="100px"></el-table-column>
      <el-table-column show-overflow-tooltip sortable prop="eightBitCodeName" label="8位码名称" min-width="180px"></el-table-column>
      <el-table-column show-overflow-tooltip sortable prop="supplierCode" label="供应商编号" min-width="100px"></el-table-column>
      <el-table-column show-overflow-tooltip sortable prop="supplierName" label="供应商名称" min-width="100px"></el-table-column>
      <el-table-column show-overflow-tooltip sortable prop="pickupPoint" label="发货市" min-width="80px"></el-table-column>
      <el-table-column show-overflow-tooltip sortable prop="dcName" label="到货仓库" min-width="90px"></el-table-column>
      <el-table-column show-overflow-tooltip sortable prop="temperatureI18n" label="温区" min-width="80px"></el-table-column>
      <el-table-column show-overflow-tooltip sortable prop="unitI18n" label="结算单位" min-width="90px"></el-table-column>
      <el-table-column show-overflow-tooltip sortable prop="transportaionMethodI18n" label="运输方式" min-width="100px"></el-table-column>
      <el-table-column show-overflow-tooltip sortable prop="isSpecialFreight" label="非标准线路运费" min-width="140px">
        <template slot-scope="scope">{{scope.row.isSpecialFreight=='Y'?'是':'否'}}</template>
      </el-table-column>
      <el-table-column show-overflow-tooltip sortable prop="status" label="状态" min-width="80px">
        <template slot-scope="scope">
          {{scope.row.status|ic('TT_SOURCING','STATUS')}}
        </template>
      </el-table-column>
      <el-table-column show-overflow-tooltip sortable prop="auditor" align="center" :label="$t('quoteByLine.sourcing.auditor')" min-width="180px"></el-table-column>
      <el-table-column show-overflow-tooltip sortable prop="creater" label="创建人" min-width="180px"></el-table-column>
      <el-table-column show-overflow-tooltip sortable prop="createDate" label="创建日期" min-width="100px">
        <template slot-scope="scope">
          {{scope.row.createDate | dateFormatFilter("YYYY-MM-DD")}}
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination">
      <el-pagination :layout="pageLayout" @size-change="pageSizeChange($event,'queryCondition','setTable')" @current-change="pageNumberChange($event,'queryCondition','setTable')" :current-page="queryCondition.pageNum" :page-sizes="pageSizeList" :page-size="queryCondition.pageSize" :total="totalCount"></el-pagination>
    </div>
    <el-dialog :visible.sync="showSelSupplierDialog" append-to-body width="80%">
      <SelSupplier ref="supplierSelRef" @subCallMethod="selectSupplierMethod"></SelSupplier>
    </el-dialog>
  </div>
</template>
<script>
import { searchSourcing } from "@/api/quoteByProduct.js";
import sourcingProductApi from "@/api/quoteByProduct/sourcingProduct";
import PickupUser from "@/components/common/pickupUser";
import dataTableUtils from "@/utils/dataTableUtils";
import { Message } from "element-ui";
import SelSupplier from '@/components/page/base-data/carrier-sel-page';
import IcSelect from "@/components/common/icSelect";
import DateRanger from "@/components/common/dateRanger";
import store from '@/store/index'
import paginationMixin from '../../../../mixins/pagitionMixin';
export default {
  name: "sourcingByProduct",
  mixins: [paginationMixin],
  components: { DateRanger, IcSelect, PickupUser, SelSupplier },
  data() {
    return {
      isShow: false,//控制查询列表收缩展开
      showSelSupplierDialog: false,
      activeName: 'first',
      isSpecialFreightList: [
        {
          key: "Y",
          label: "是",
        },
        {
          key: "N",
          label: "否",
        }
      ],
      queryCondition: {
        pageNum: 1, //当前页
        pageSize: 15, //每页多少条
        sourcingNo: null,
        applyNo: null,
        subject: null,
        tmSupplierId: null,
        dateFrom: "",
        dateTo: "",
        auditDateStart: null,
        auditDateEnd: null,
        creater: null,
        auditor: '',
        status: null,
        isSpecialFreight: null,
        eightBitCodesStr: null,
        eightBitCodes: [],
      },
      totalCount: null,
      tableData: [],
      sourcing: {},
      page: {
        size: 10,
        current: 1,
        total: 0
      },
      multipleSelection: [],
      eightLists: []
    };
  },
  created() {
  },
  mounted() {
  },
  watch: {
    queryCondition() {
      let _this = this;
      store.dispatch('uploadListParams', { routeName: _this.$route.name, reqData: _this.queryCondition })
    }
  },
  beforeRouteEnter(to, from, next) {
    const eightBitCodesStr = to.meta.reqData.eightBitCodesStr
    let eightBitCodesArr = []
    if (eightBitCodesStr && eightBitCodesStr.length > 0) {
      eightBitCodesArr = eightBitCodesStr.trim().split(/[\n,，; \s]+/g);
    }
    const requestData = Object.assign({}, to.meta.reqData)
    requestData.eightBitCodes = eightBitCodesArr
    sourcingProductApi.list(requestData).then((res) => {
      next(vm => {
        vm.queryCondition = requestData;
        vm.tableData = res.resultData;
        vm.totalCount = res.totalCount;
      })
    })
  },
  extends: dataTableUtils,
  methods: {
    setTable(val) {
      if (undefined != val) {
        this.queryCondition.pageNum = 1;
      }
      const eightBitCodesStr = this.queryCondition.eightBitCodesStr
      let eightBitCodesArr = []
      if (eightBitCodesStr && eightBitCodesStr.length > 0) {
        eightBitCodesArr = eightBitCodesStr.trim().split(/[\n,，; \s]+/g);
      }
      const requestData = Object.assign({}, this.queryCondition)
      this.$set(requestData, 'eightBitCodes', eightBitCodesArr)
      sourcingProductApi.list(requestData).then(resp => {
        this.tableData = resp.resultData;
        this.totalCount = resp.totalCount;
      })
    },
    openQuotationApplyDetail: function (row) {
      this.$router.push({
        path: `/product-quotation-application-add`,
        query: {
          applyId: row.ttQuotationApplyId,
          source: "apply",
          applyType: row.applyType
        }
      });
    },
    // onChangeClick(val) {
    //   console.log('8位码:', val);
    //   this.eightLists = []
    //   var arr = val.split(';')
    //   for (let i = 0; i < arr.length; i++) {
    //     this.eightLists.push({
    //       aaa: arr[i]
    //     })
    //   }
    // },
    showDetail(id) {
      let that = this;
      if (this.actionCheck.actionCheck('Sourcing-productDetail') === false) {
        this.$message.error(this.$t('common.noPermission'))
        return false
      }
      that.$router.push({
        path: `/sourcingByProduct-detail`,
        query: {
          sourcingNo: id,
        }
      });
    },
    restQueryForm: function () {
      this.$refs.queryCondition.resetFields();
      this.queryCondition = {
        pageNum: 1, //当前页
        pageSize: 15, //每页多少条
        sourcingNo: null,
        applyNo: null,
        subject: null,
        tmSupplierId: null,
        dateFrom: "",
        dateTo: "",
        auditDateStart: null,
        auditDateEnd: null,
        creater: null,
        auditor: '',
        status: null,
        isSpecialFreight: null,
        eightBitCodesStr: null,
        eightBitCodes: [],
      }
      this.$refs.dataTable.clearSelection();
      this.setTable();
    },
    handleSizeChange(e) {
      this.page.size = e;
    },
    handleCurrentChange(e) {
      this.page.current = e;
    },

    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    selectSupplierMethod: function (supList) {
      this.queryCondition.tmSupplierIds = [];
      this.queryCondition.supplierCode = '';
      supList.forEach((item) => {
        this.queryCondition.tmSupplierIds.push(item.tmSupplierId);
        this.queryCondition.supplierCode = this.queryCondition.supplierCode + item.supplierCode + ',';
      });
      this.queryCondition.supplierCode = this.queryCondition.supplierCode.substr(0, this.queryCondition.supplierCode.length - 2)

      this.showSelSupplierDialog = false;
    },
    sendMail() {
      let rows = this.$refs.dataTable.selection;
      if (rows.length <= 0) {
        this.$message({ message: "请选择需要发送中标通知", type: "warning" });
        return;
      } else {
        if (rows.filter(row => row.status != "COMPLETE").length > 0) {
          this.$message({ message: this.$t("quoteByLine.sourcing.unqualifiedData"), type: "warning" });
          return;
        }
        this.$confirm(this.$t('quoteByLine.sourcing.confirmSendMail'), this.$t('common.tips'), {
          confirmButtonText: this.$t('common.confirm'),
          cancelButtonText: this.$t('common.cancel'),
          type: 'warning'
        }).then(() => {
          sourcingProductApi.sendSourcingMail(rows).then(res => {
            if (res.totalCount > 0) {
              //发送邮件失败
              Message({ message: res.resultData + this.$t('quoteByLine.sourcing.sendMailFailed'), type: "warning" });
            } else {
              Message({ message: this.$t('quoteByLine.sourcing.sendMailSuccess'), type: "success" });
            }
          });
        })
      }
    }
  }
};
</script>
<style scoped lang="scss">
.fixedPointProductQuotation {
  .toolsBox {
    margin-bottom: 10px;
  }
  .el-input {
    width: 100%;
  }
  .el-select {
    width: 100%;
  }
  .el-date-editor.el-input,
  .el-date-editor.el-input__inner {
    width: 100%;
  }
}
</style>
